import React, { useState, useEffect } from 'react';
import { metrics } from '../api';

function Metrics() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadMetrics();
  }, []);

  const loadMetrics = async () => {
    try {
      const response = await metrics.getAll();
      setData(response.data);
    } catch (error) {
      console.error('Error loading metrics:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div className="spinner"></div>;
  if (!data) return <div>No data available</div>;

  return (
    <div>
      <div className="page-header">
        <h1 className="page-title">Metrics & Analytics</h1>
        <p className="page-subtitle">Recruitment performance insights</p>
      </div>

      <div className="grid grid-4 mb-4">
        <div className="card">
          <h3 className="card-title">Total Positions</h3>
          <div style={{ fontSize: '2rem', fontWeight: 'bold', color: 'var(--primary-color)' }}>
            {data.positions?.total || 0}
          </div>
          <small className="text-secondary">
            {data.positions?.open || 0} open, {data.positions?.filled || 0} filled
          </small>
        </div>
        <div className="card">
          <h3 className="card-title">Total Applicants</h3>
          <div style={{ fontSize: '2rem', fontWeight: 'bold', color: 'var(--secondary-color)' }}>
            {data.applicants?.total || 0}
          </div>
          <small className="text-secondary">All time</small>
        </div>
        <div className="card">
          <h3 className="card-title">Recent Applications</h3>
          <div style={{ fontSize: '2rem', fontWeight: 'bold', color: 'var(--info-color)' }}>
            {data.recentApplications || 0}
          </div>
          <small className="text-secondary">Last 30 days</small>
        </div>
        <div className="card">
          <h3 className="card-title">Hire Rate</h3>
          <div style={{ fontSize: '2rem', fontWeight: 'bold', color: 'var(--success-color)' }}>
            {data.hireRate || 0}%
          </div>
          <small className="text-secondary">Success rate</small>
        </div>
      </div>

      <div className="grid grid-2">
        <div className="card">
          <h3 className="card-title">Applicant Status Breakdown</h3>
          <div className="table-container">
            <table className="table">
              <thead>
                <tr>
                  <th>Status</th>
                  <th>Count</th>
                  <th>Percentage</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <span className="badge badge-warning">Active</span>
                  </td>
                  <td><strong>{data.applicants?.active || 0}</strong></td>
                  <td>
                    {data.applicants?.total > 0 
                      ? ((data.applicants.active / data.applicants.total) * 100).toFixed(1)
                      : 0}%
                  </td>
                </tr>
                <tr>
                  <td>
                    <span className="badge badge-success">Hired</span>
                  </td>
                  <td><strong>{data.applicants?.hired || 0}</strong></td>
                  <td>
                    {data.applicants?.total > 0 
                      ? ((data.applicants.hired / data.applicants.total) * 100).toFixed(1)
                      : 0}%
                  </td>
                </tr>
                <tr>
                  <td>
                    <span className="badge badge-secondary">Released</span>
                  </td>
                  <td><strong>{data.applicants?.released || 0}</strong></td>
                  <td>
                    {data.applicants?.total > 0 
                      ? ((data.applicants.released / data.applicants.total) * 100).toFixed(1)
                      : 0}%
                  </td>
                </tr>
                <tr>
                  <td>
                    <span className="badge badge-danger">Terminated</span>
                  </td>
                  <td><strong>{data.applicants?.terminated || 0}</strong></td>
                  <td>
                    {data.applicants?.total > 0 
                      ? ((data.applicants.terminated / data.applicants.total) * 100).toFixed(1)
                      : 0}%
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div className="card">
          <h3 className="card-title">Top Positions by Applications</h3>
          <div className="table-container">
            <table className="table">
              <thead>
                <tr>
                  <th>Position</th>
                  <th>Location</th>
                  <th>Applicants</th>
                </tr>
              </thead>
              <tbody>
                {data.applicationsByPosition?.map((item, idx) => (
                  <tr key={idx}>
                    <td><strong>{item.title}</strong></td>
                    <td>{item.location || 'N/A'}</td>
                    <td>{item.count}</td>
                  </tr>
                ))}
                {(!data.applicationsByPosition || data.applicationsByPosition.length === 0) && (
                  <tr>
                    <td colSpan="3" className="text-center text-secondary">
                      No positions with applications yet
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div className="card mt-4">
        <h3 className="card-title">Overview Summary</h3>
        <div className="grid grid-3 mt-3">
          <div style={{ textAlign: 'center', padding: '1rem' }}>
            <div style={{ fontSize: '1.5rem', fontWeight: 'bold', color: 'var(--primary-color)' }}>
              {data.positions?.open || 0}
            </div>
            <div className="text-secondary">Open Positions</div>
          </div>
          <div style={{ textAlign: 'center', padding: '1rem' }}>
            <div style={{ fontSize: '1.5rem', fontWeight: 'bold', color: 'var(--warning-color)' }}>
              {data.applicants?.active || 0}
            </div>
            <div className="text-secondary">Active Applicants</div>
          </div>
          <div style={{ textAlign: 'center', padding: '1rem' }}>
            <div style={{ fontSize: '1.5rem', fontWeight: 'bold', color: 'var(--success-color)' }}>
              {data.applicants?.hired || 0}
            </div>
            <div className="text-secondary">Total Hires</div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Metrics;
